import React from "react";
import { useI18n } from "../i18n";

/**
 * The "?" in the top bar, right beside the language. A dot says there is
 * something in "What's new" this device has not read yet.
 */
const HelpButton = ({ onClick, hasNews, open }) => {
  const { t } = useI18n();

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t("help.open")}
      aria-haspopup="dialog"
      aria-expanded={open}
      title={t("help.open")}
      className="relative shrink-0 h-10 w-10 inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white text-lg font-bold text-primary-700 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-primary-500"
    >
      <span aria-hidden="true">?</span>
      {hasNews && (
        <span
          aria-hidden="true"
          className="absolute -top-1 -end-1 h-3 w-3 rounded-full bg-rose-500 ring-2 ring-white"
        />
      )}
    </button>
  );
};

export default HelpButton;
